import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../app.config';
import { ConnectionService } from '@services/connection-service';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { Location } from '@angular/common';

const DEFAULT_IMAGES = {
  en: [
    "https://cdn.cureskin.com/app/img/moneyBack_english_1.png",
    "https://cdn.cureskin.com/app/img/moneyBack_english_2.png",
    "https://cdn.cureskin.com/app/img/moneyBack_english_3.png"
  ],
  hi: [
    "https://cdn.cureskin.com/app/img/moneyBack_hindi_1.png",
    "https://cdn.cureskin.com/app/img/moneyBack_hindi_2.png",
    "https://cdn.cureskin.com/app/img/moneyBack_hindi_3.png"
  ],
}

@Component({
  selector: 'moneyback-guarantee-page',
  templateUrl: './moneyback-guarantee-page.component.html',
  imports: []
})
export class MoneybackGuaranteePageComponent implements OnInit {
  images: Array<string> = [];
  isIosDevice: boolean = false;

  constructor(
    private readonly conn: ConnectionService,
    public readonly appConfig: AppConfig,
    private readonly location: Location,
    private readonly appWebBridge: AppWebBridgeService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.isIosDevice = await this.appWebBridge.isIosDevice();
    const user = await this.conn.getActingUser();
    const experiments = await this.conn.findUserActiveExperiments();
    const moneyBackExperiment = experiments?.find((experiment) => experiment.key === 'money_back_guarantee');
    if (!moneyBackExperiment) {
      this.images = DEFAULT_IMAGES?.[user?.get('languagePreference')] ?? DEFAULT_IMAGES?.[this.appConfig.Shared.Languages.EN];
    } else {
      this.images = moneyBackExperiment?.variant?.pageImages?.[user?.get('languagePreference')] ?? moneyBackExperiment?.variant?.pageImages?.[this.appConfig.Shared.Languages.EN];
    }
  }

  navigateBack(): void {
    this.location.back();
  }
}
